<template>
  <div class="program">
    <h2 class="fs30">解决方案</h2>
    <div class="list">
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="item-header">
          <img :src="item.icon" />
        </div>
        <div class="item-body">
          <div class="item-body-title">{{item.title}}</div>
          <div class="item-body-desc">{{item.desc}}</div>
        </div>
        <div class="item-footer">
          <div class="item-footer-detail" @click="$router.push(`/solution/detail/${item.id}`)">查看详情</div>
        </div>
      </div>
    </div>
    <div class="more" @click="$router.push('/solution')">
      <img src="../../../../static/images/home_button@2x.png" />
      <span>查看更多</span>
    </div>
    <figure class="bg"></figure>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  data () {
    return {
      list: [{
        id: 1,
        title: '互联网+保险',
        desc: '针对保险业务，打造移动分销平台、电商 平台等，提升保险服务的便捷性。',
        icon: require('../../../../static/images/hiome_Program_icon1@2x.png')
      }, {
        id: 2,
        title: '互联网+智慧城市',
        desc: '从市政服务层面，建设体系化移动城市应 用让人们生活更便利更安全。',
        icon: require('../../../../static/images/hiome_Program_icon2@2x.png')
      }, {
        id: 3,
        title: '互联网+智能财税',
        desc: '帮助财税企业打造智能化、高效化、规范 化财税服务。',
        icon: require('../../../../static/images/hiome_Program_icon3@2x.png')
      }, {
        id: 5,
        title: '互联网+智慧医疗',
        desc: '开发中医诊所后台管理平台，实现医生管 理与问诊一整套的线上服务。',
        icon: require('../../../../static/images/hiome_Program_icon4@2x.png')
      }]
    }
  },
  computed: {},
  methods: {},
  created () {},
}
</script>

<style scoped>
.program {
  position: relative;
  height: 762px;
}
.bg {
  width: 1920px;
  height: 762px;
  background-image: url('https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_program_background%402x.png');
  background-size: 1920px 762px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  z-index: -1;
}
.fs30 {
  font-size: 30px;
  color: #ffffff;
}
.program h2 {
  text-align: center;
  padding: 80px 0 60px 0;
}
.list {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: auto;
}
.item {
  width: 22%;
  height: 360px;
  border-radius: 8px;
  background-color: #fff;
  overflow: hidden;
}
.item-header {
  height:160px;
  background: linear-gradient(0deg,rgba(244,98,82,1) 0%,rgba(251,60,60,1) 100%);
  background-size: 100% 160px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.item-header img {
  width: 80px;
}
.item-body {
  text-align: center;
  padding: 30px 24px 0;
  font-size: 24px;
}
.item-body-title {
  font-size: 1em;
  color:rgba(51,51,51,1);
  font-family:Microsoft YaHei;
  font-weight:400;
}
.item-body-desc {
  font-size: .5em;
  color:rgba(153,153,153,1);
  margin-top: 12px;
}
.item-footer-detail {
  width:96px;
  height:32px;
  line-height: 32px;
  background:rgba(255,87,78,1);
  font-size: 14px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(255,255,255,1);
  text-align: center;
  margin: 30px auto 0;
  cursor: pointer;
}
.item-footer-detail:hover {
  background:#dc170d;
}
.more {
  width:176px;
  height:48px;
  background:rgba(255,87,78,1);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size:18px;
  color:rgba(255,255,255,1);
  margin: 80px auto 0;
  cursor: pointer;
}
.more:hover {
  background:#dc170d;
}
.more img {
  width: 24px;
  height: 24px;
  transform: translateY(1px);
  margin-right: 8px;
}
@media (max-width: 1199px) and (min-width: 992px){
  .list {
    padding: 0 10px;
  }
  .item-body-title {
    font-size: 0.9em;
  }
  .fs30 {
    font-size: 28px;
  }
}
@media (max-width: 991px) and (min-width: 768px){
  .list {
    padding: 0 10px;
  }
  .item-body-title {
    font-size: 0.7em;
  }
  .item-body-desc {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .fs30 {
    font-size: 26px;
  }
}
@media screen and (max-width: 767px){
  .fs30 {
    font-size: 24px;
  }
  .list {
    padding: 0 10px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/index/program/program.vue